import AppRoutes from './routes';
import ReactQueryProvider from './providers/ReactQueryProvider';
import { ToasterStyling } from './lib/ToasterStyling';
import QueryErrorResetBoundary from './components/error/QueryErrorResetBoundary';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <ReactQueryProvider>
      <ToasterStyling />
      <QueryErrorResetBoundary>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </QueryErrorResetBoundary>
    </ReactQueryProvider>
  );
}

export default App;
